rjm.ui.ChartBuilderTimeIntervalView = rjm.ui.ChartBuilderBlockableView.extend(
  events:
    "click .dropdown-menu li a": "changeTimeInterval"

  initialize: (options) ->
    if not options or not options.chartModel or not options.viewState
      throw "InvalidConstructorArgs - ChartBuilderTimeIntervalView"

    _.bindAll this, "listenToTrendMinTime", "changeTimeInterval", "disableAllButNone", "selectBestInterval", "disableEnums", "generateTemplateData", "render"

    @chartModel = options.chartModel
    @viewState = options.viewState

    @listenTo @chartModel, "change:isTimeOnXAxis change:timeInterval", @render 
    @listenTo @chartModel.getCurrentSeries(), "change:trend", (series) =>
      #hack to check to make sure a trend is really changing becaues of all the silents we throw around
      #can be fixed when we make trend_id an idAttribute
      if series.get('trend').id isnt @chartModel.getCurrentSeries().get("trend").id
        @selectBestInterval()
      else
        @render()
      if @chartModel.hasTimestamp()
        @unblock()
      @stopListening(@chartModel.getCurrentSeries().get("trend"), "change:minTime")
      @listenToTrendMinTime()
    @listenTo @chartModel.get("timeFrame"), "change", @render
    @listenTo @chartModel, "change:api_conn_id", @block
    @listenToTrendMinTime()

    return

  listenToTrendMinTime: ->
    @listenTo @chartModel.getCurrentSeries().get("trend"), "change:minTime", (trend, minTime) ->
      unless @viewState.get("trendsOnly")
        @render()

  changeTimeInterval: (e) ->
    e.preventDefault()
    if @$(e.target).hasClass("disabled") or @$(e.target).parent().hasClass("disabled")
      return
    enumId = $(e.target).parent().data("value")
    #chart is set to not be over time, so update the model
    if enumId is 'NONE'
      @chartModel.set isTimeOnXAxis: false
    else #chart is over time
      @chartModel.set isTimeOnXAxis: true

    @chartModel.set timeInterval: rjm.app.enums.timeInterval[enumId]
    @render()

  disableAllButNone: ->
    @$(".item").each (i, element) => #need to disable each element
      if $(element).data('id') is 'NONE'
        $(element).removeClass("disabled").addClass("selected")
      else
        $(element).addClass("disabled").removeClass("selected")

  #TODO: push this logic into the chartmodel or time interval model so other views can use this to 'intelligently' select time intervals
  selectBestInterval: ->
    @chartModel.set
      isTimeOnXAxis: true
    idealDataPoints = 31 #TODO: is this good?
    dataPoints = @chartModel.getNumberOfDataPoints()
    min = null
    dataPointKey = null
    for key of dataPoints
      if dataPoints.hasOwnProperty(key)
        diff = (Math.abs(dataPoints[key] - idealDataPoints))
        if _(min).isNull() or diff <= min
          min = diff
          dataPointKey = key

    #defaults to MONTH when we can't determine the best interval (happens when we are looking at an all-time chart)
    #note that new charts will also default to MONTH because the ChartController endpoint returns a chart that is all-time with monthly time interval
    if dataPointKey? then @chartModel.set timeInterval: rjm.app.enums.timeInterval[dataPointKey] else @chartModel.set timeInterval: rjm.app.enums.timeInterval.MONTH
    @render()
    return

  disableEnums: ->
    #disable time frames that are too large for the current period 
    if @chartModel.get("timeFrame").get("type") isnt rjm.app.enums.timeFrameType.ALL_TIME and not @chartModel.get('series').at(0).get('cohortDescriptor')?
      numberOfSeconds = @chartModel.get("timeFrame").getNumberOfSecondsInRange(@chartModel.getCurrentSeries().get("trend").get("minTime"))
      if numberOfSeconds?
        for interval,value of rjm.app.enums.timeInterval
          if numberOfSeconds < value.secondsInInterval
            @$("[data-value='"+value.serializedValue+"']").addClass "disabled"

    #disable NONE option for cohort charts and certain perspectives
    if @chartModel.get('series').at(0).get('cohortDescriptor')?
      @$("[data-value='NONE']").addClass "disabled"
      @$("[data-value='HOUR']").addClass "disabled"
    else
      @$("[data-value='NONE']").removeClass "disabled"

    return

  generateTemplateData: ->
    #we need to clone the timeInterval object before adding NONE to it
    #to avoid mutating the original object
    timeIntervals = _(rjm.app.enums.timeInterval).clone();
    timeIntervals.NONE = {names: "None"}
    currentTime: (new Date()).toString()
    isTimeOnXAxis: @chartModel.get("isTimeOnXAxis")
    timeIntervals: timeIntervals
    intervalPropertyName: "names"
    currentInterval: (if @chartModel.has("timeInterval") and @chartModel.get("isTimeOnXAxis") then @chartModel.get("timeInterval").serializedValue else "NONE")
    currentIntervalName: (if @chartModel.has("timeInterval") and @chartModel.get("isTimeOnXAxis") then @chartModel.get("timeInterval").names else "None")

  render: ->
    @$el.html ich.chartBuilderTimeInterval(@generateTemplateData())

    if @chartModel.isGAChart() and not @chartModel.getCurrentSeries().get("trend").isGATrend()
      @block()
    else unless @chartModel.hasTimestamp()
      @block()
    else
      @unblock()
      @disableEnums()

    return @
)
